import {Option} from './option';

export class Cab {
    exportadas?: Option;
    gravadas?: Option;
    inafectas?: Option;
    exoneradas?: Option;
    totalImpuestos: any[];
    cargoDescuento: any[];
    sumOtrosCargos: number;
    montoTotalImpuestos: number;
    importeTotal: number;
    tipoOperacion: string;
    leyenda: any[];


    constructor(exportadas: Option = null,
                gravadas: Option = null,
                inafectas: Option = null,
                exoneradas: Option = null,
                totalImpuestos: any[] = [],
                cargoDescuento: any[] = null,
                sumOtrosCargos: number = 0,
                montoTotalImpuestos: number = 0,
                importeTotal: number = 0,
                tipoOperacion: string = '',
                leyenda: any[] = null) {
        this.exportadas = exportadas;
        this.gravadas = gravadas;
        this.inafectas = inafectas;
        this.exoneradas = exoneradas;
        this.totalImpuestos = totalImpuestos;
        this.cargoDescuento = cargoDescuento;
        this.sumOtrosCargos = sumOtrosCargos;
        this.montoTotalImpuestos = montoTotalImpuestos;
        this.importeTotal = importeTotal;
        this.tipoOperacion = tipoOperacion;
        this.leyenda = leyenda;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/cab.ts